import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=adf64f36&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"
import style0 from "./admin.vue?vue&type=style&index=0&id=adf64f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf64f36",
  null
  
)

export default component.exports